import React from 'react';
import { Link } from 'react-router-dom';
import { PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';
import './styles.scss';
import ProductCard from '../ProductCard';

const OrderDetailsPopover = ({ id }) => {
  // const id = `comment-${uniqueId()}`;

  const products = [
    {
      id: '1',
      name: 'Бордовое базовое худи с флисом',
      img: 'https://images.ua.prom.st/1616027834_w640_h640_bryuki-muzhskie-yoshimitsu.jpg'
    },
    {
      id: '2',
      name: 'Желто-черная худи с белым вставками с флисом',
      img: 'https://oxxxyshop.com/wa-data/public/shop/products/08/01/108/images/487/487.750@2x.jpg'
    },
    {
      id: '3',
      name: 'Желто-черная худи с белым вставками с флисом',
      img: 'https://oxxxyshop.com/wa-data/public/shop/products/08/01/108/images/487/487.750@2x.jpg'
    },
    {
      id: '4',
      name: 'Желто-черная худи с белым вставками с флисом',
      img: 'https://oxxxyshop.com/wa-data/public/shop/products/08/01/108/images/487/487.750@2x.jpg'
    },
    {
      id: '5',
      name: 'Желто-черная худи с белым вставками с флисом',
      img: 'https://oxxxyshop.com/wa-data/public/shop/products/08/01/108/images/487/487.750@2x.jpg'
    }
  ];

  return (
    <>
      <Link id={`order-popover-${id}`} style={{ minWidth: '16px', display: 'inline-block' }}>{id}</Link>

      <UncontrolledPopover trigger="hover" placement="right" target={`order-popover-${id}`} className="order-popover_container">
        <PopoverHeader>Детали заказа #{id}</PopoverHeader>
        <PopoverBody className="order-popover">
          <div className="order-popover_contacts">
            <div className="product-details_block">
              <div className="product-details_block_heading">Получатель</div>
              Максим Дяченко
            </div>

            <div className="product-details_block">
              <div className="product-details_block_heading">Поставщик</div>
              DropSpot
            </div>
          </div>
          <div className="order-popover_products">
            {products.map(product => <ProductCard lean={true} product={product} key={product.id}/>)}
          </div>
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
};

export default OrderDetailsPopover;
